/**
 * This error means that this error should not be logged in Sentry.
 * Examples are: canceledRequests, offline users
 */

export class IgnorableNetworkError extends Error {
}

export default IgnorableNetworkError;
